import React from "react";
import { Outlet } from "react-router-dom";
import styles from "./layout.module.css";
import { Header } from "./header";

export const Layout = () => {
  return (
    <>
      <Header />
      <div className={styles.wrapper}>
        <Outlet />
      </div>
    </>
  );
};
